module.exports = __webpack_public_path__ + "img/transfer_active.1aa515f6.svg";